import { cn } from '@rental/ui'
import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'

const SURFACE = {
  pane: 'glass-pane rounded-card',
  well: 'rounded-sm bg-surface-well',
  plain: '',
} as const

/**
 * A part closed until asked for (UI-2g): one look for all of them, a native
 * disclosure that opens by keyboard and on iPadOS 16.4 with no script of its
 * own, its summary a finger tall with a chevron that turns. It stands on its
 * own pane on a screen, on a well inside a section's pane, and on nothing
 * inside a well already there (`plain`): a well in a well is no recess.
 */
export function Disclosure({
  summary,
  surface,
  className,
  children,
}: {
  summary: ReactNode
  surface: keyof typeof SURFACE
  className?: string
  children: ReactNode
}) {
  const inset = surface === 'plain' ? '' : 'px-4 sm:px-6'
  return (
    <details className={cn('group', SURFACE[surface], className)}>
      <summary
        className={cn(
          'flex min-h-touch cursor-pointer list-none items-center gap-2 font-medium text-link',
          inset,
        )}
      >
        <ChevronRight
          aria-hidden="true"
          className="size-4 shrink-0 transition-transform group-open:rotate-90"
        />
        {summary}
      </summary>
      <div
        className={cn(
          'flex flex-col gap-3 border-t border-rule',
          surface === 'plain' ? 'pt-3' : 'p-4 sm:px-6',
        )}
      >
        {children}
      </div>
    </details>
  )
}
